import React, { useState } from 'react';
import { message, Spin } from 'antd';
import classNames from 'classnames';
import { CourseArchiveIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { useAppSelector } from 'store';

import { useSaveCourse } from 'modules/courses/hooks';

import { Visible } from 'components';

interface IProps {
  isSaved?: boolean;
  teacherCourseId?: number;
}

const SaveCourse: React.FC<IProps> = ({ isSaved, teacherCourseId }) => {
  const t = useTranslations();
  const [saved, setSaved] = useState(isSaved);
  const { mutate, isLoading } = useSaveCourse();
  const isAuth = useAppSelector(({ user }) => user?.phone);

  const onSaveToggle = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    event.preventDefault();

    if (isLoading) return;

    if (!isAuth) {
      message.info(`${t('kurslarni_saqlab_olish_uchun_royxatdan_oting')}`);
      return;
    }

    mutate(
      { teacherCourseId, action: saved ? 'remove' : 'add' },
      {
        onSuccess: () => {
          setSaved(!saved);
        }
      }
    );
  };

  return (
    <div
      onClick={onSaveToggle}
      className={classNames(
        'absolute right-2 top-2 z-10 flex size-7 items-center justify-center rounded-full backdrop-blur-lg',
        {
          'bg-white/40': !saved,
          'bg-orange-200/40': saved
        }
      )}
    >
      <Visible
        if={isLoading}
        else={
          <Visible
            if={saved}
            else={
              <span className="text-white">
                <CourseArchiveIcon />
              </span>
            }
          >
            <span className="text-orange-500">
              <CourseArchiveIcon />
            </span>
          </Visible>
        }
      >
        <Spin size="small" />
      </Visible>
    </div>
  );
};

export default SaveCourse;
